import { createActionName } from "../../../utility"

export const reducerName = "toasts"

// action names
export const SHOW_TOAST = createActionName(reducerName, "SHOW_TOAST")
export const DISMISS_TOAST = createActionName(reducerName, "DISMISS_TOAST")
